import { render, staticRenderFns } from "./ListChannelWhatsapp.vue?vue&type=template&id=19dc92b4&scoped=true&"
import script from "./ListChannelWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ListChannelWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc92b4",
  null
  
)

export default component.exports